import {Component, EventEmitter, Input, Output} from '@angular/core';

import {FormSelectItem} from '../../../../model/form/select-item.model';
import { AbstractControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgIf, NgClass, NgFor } from '@angular/common';

@Component({
    selector: 'app-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    imports: [NgIf, FormsModule, ReactiveFormsModule, NgClass, NgFor]
})
export class SelectComponent {
    @Input() submitted: boolean; // Si le form a été soumis au moins une fois
    @Input() control: AbstractControl; // FormControl
    @Input() required = false; // Si le form est requis ou non
    @Input() errorMsg: string; // Message si l'input est required
    @Input() disabled: boolean;
    @Input() fcName: string; // Nom du FormControl
    @Input() textLabel: string; // Label
    @Input() group; // Group contenant le FormControle
    @Input() items: Array<FormSelectItem>;
    @Input() i = 0; // i si l'input est dans une boucle (pour éviter d'avoir 2 composants ayant le même id

    @Input() modelAttribute: unknown; // Valeur entrée
    @Output() modelAttributeChange = new EventEmitter(); // Valeur envoyée au parent

    change(newValue) {
        this.modelAttribute = newValue;
        this.modelAttributeChange.emit(newValue);
    }
}
